import { render } from "./ConfirmationBanner.vue?vue&type=template&id=8b938126&scoped=true"
import script from "./ConfirmationBanner.vue?vue&type=script&lang=js"
export * from "./ConfirmationBanner.vue?vue&type=script&lang=js"

import "./ConfirmationBanner.vue?vue&type=style&index=0&id=8b938126&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3487515193/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b938126"]])

export default __exports__